import { createFileRoute } from '@tanstack/react-router'
import ListingRequestsManagement from '@/views/super-admin/listing-requests'

export const Route = createFileRoute('/_authenticated/super-admin-listing-requests')({
  component: ListingRequestsManagement,
})
